import { Roles } from "@shared/Roles";
import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { doesExist } from "@shared/backend/entity-security/does-exist";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { remult } from "remult";
import { Category } from "../category";
import { type SubCategory } from "./entity";

export const SubCategoryEntityConfig: HyperEntityConfig<SubCategory> = {
  allowApiCrud: Roles.AdminsAndManager,
  async apiPrefilterPerRole(filter) {
    filter(Roles.All, {
      category: { $is: await copyApiPrefilterPerRole(Category) },
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.OrganizationManagers, (entity) =>
      doesExist(Category, {
        id: entity.category!.id,
        organization: {
          $id: remult.user!.organizationId!,
        },
      }),
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);

    allow(Roles.OrganizationManagers, {
      category: {
        $is: {
          organization: {
            $id: remult.user!.organizationId!,
          },
        },
      },
    });
  },
};
